// Export API URL from environment variable
export const API_URL = process.env.REACT_APP_API_URL || process.env.API_URL;

if (!API_URL) {
  throw new Error('REACT_APP_API_URL environment variable is not set');
}

// Remove trailing slashes for consistency
export const API_BASE_URL = API_URL.replace(/\/+$/, '');

// Base API configuration
export const API_CONFIG = {
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
} as const;

// Audio recording configuration
export const AUDIO_CONFIG = {
  android: {
    extension: '.mp4',
    outputFormat: 'mpeg_4',
    audioEncoder: 'aac',
    sampleRate: 44100,
    numberOfChannels: 2,
    bitRate: 128000,
  },
  ios: {
    extension: '.m4a',
    outputFormat: 'mpeg_4',
  },
  web: {
    extension: '.webm',
    mimeType: 'audio/webm',
  },
};

// Enable or disable audio call feature
export const ENABLE_AUDIO_CALL = false; // Set to false to disable
